import React, { useState } from 'react';

export default function FallbackImage({ className, url, alternativeUrl }) {
    const [loadError, setLoadError] = useState(false);

    return (
        <img className={className} src={loadError || !url ? alternativeUrl : url} onError={() => setLoadError(true)} />
    );
}
